import React from 'react';

type Props = {
  hideTitle?: boolean,
};

export default function Contact(props: Props): React.ReactElement {
  return (
    <div className="qa-item">
      {!props.hideTitle && (
        <>
          <h2>
            Contact
          </h2>
          <br />
          <h3 className="qa-question">
            Vous avez une question ?
          </h3>
        </>
      )}
      <p>
        Vous pouvez contacter la Hotline ADSN pour régler vos difficultés rapidement.
      </p>
      <br />
      <p>
        Numéro vert :
        {' '}
        <a className="green-number" href="tel:0 800 306 212">0 800 306 212</a>
      </p>
      <p>
        Du Lundi au Vendredi de 8h30 à 21h
        <br />
        Le Samedi de 8h30 à 12h
      </p>
    </div>
  );
}
